import { CustomerDetailViewModel, CustomerSummaryViewModel } from "@payping/api";

export function getCustomerLabel(customer: CustomerSummaryViewModel | CustomerDetailViewModel): string {
  return (
    customer.businessName ||
    (customer.firstName && customer.lastName
      ? `${customer.firstName} ${customer.lastName}`
      : customer.firstName || customer.lastName) ||
    customer.phone ||
    customer.email ||
    customer.code ||
    ""
  );
}
